var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckboxCheckedAll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-check-box",
    clipPath: "url(#clip0_11396_182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.71131 0.200195H12.2891C12.6899 0.200195 13.0742 0.359401 13.3576 0.642789C13.641 0.926178 13.8002 1.31053 13.8002 1.71131V12.2891C13.8002 12.6899 13.641 13.0742 13.3576 13.3576C13.0742 13.641 12.6899 13.8002 12.2891 13.8002H1.71131C1.31053 13.8002 0.926178 13.641 0.642789 13.3576C0.359401 13.0742 0.200195 12.6899 0.200195 12.2891V1.71131C0.200195 1.31053 0.359401 0.926178 0.642789 0.642789C0.926178 0.359401 1.31053 0.200195 1.71131 0.200195ZM10.7644 7.51195H3V6H10.7698L10.7644 7.51195Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11396_182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckboxCheckedAll);
export default __webpack_public_path__ + "static/media/icon--checkbox-checked-all.546e05012c50fb540ae3a7d51d09265c.svg";
export { ForwardRef as ReactComponent };